// import React, { useState } from "react";
import SEO from "@/components/SEO";
import AccordianScroll from "./AccordianScroll";
import { seoConfig } from "@/config/seo.config";

export default function AboutUsContent() {
  return (
    <>
    <SEO {...seoConfig.aboutus} />
    <div>
      <div className="px-[6%]">
        <div className="text-gray-700 flex flex-col lg:flex-row lg:gap-[2px] justify-between items-center">
          <div className="lg:w-1/2">
            <h2 className="text-[28px] lg:text-[36px]">
              <b>About Us</b>
            </h2>
            <h1 className="text-[46px] lg:text-[47px] ">
              <b>Transforming How the World Manages the Sales Stack</b>
            </h1>
            <p>
              At LegittMate AI, we’re transforming the way businesses engage with prospects and customers through intelligent, real-time conversations. Our AI-powered Sales Chatbot is designed to streamline lead generation, qualify prospects, and accelerate deal closures—all while providing a seamless, personalized experience. As the world's first Assistive Intelligence platform dedicated to Sales or lead Management, we empower startups and enterprises alike to enhance customer interactions, automate follow-ups, and drive revenue growth with ease.
            </p>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <img
              src="https://d2qb2qddg7l6c6.cloudfront.net/assets/images/aboutusHero.svg"
              className="w-full lg:max-w-full"
              alt="AboutUsHero"
            />
          </div>
        </div>

        <div className="text-gray-700 flex flex-col lg:flex-row lg:gap-[2px] justify-between items-center mt-[50px] mb-[50px]">
          <div className="lg:w-1/2 flex items-center">
            <img
              src="https://d2qb2qddg7l6c6.cloudfront.net/assets/images/missionIcon.svg"
              alt="missionIcon"
            />
            <h1 className="text-[36px] lg:text-[48px] text-gray-700">
              <b>Our Mission</b>
            </h1>
          </div>
          <div className="lg:w-1/2">
            <p>
            Our mission is to empower businesses with intelligent tools to streamline their lead generation process. By leveraging the power of Assistive Intelligence, our AI-driven Sales Chatbot ensures seamless prospect engagement, qualification, and follow-up—making lead capture smarter, faster, and more efficient. We are committed to transforming how businesses interact with potential customers, enabling them to focus on closing deals while our chatbot handles the initial touchpoints with precision and effectiveness.
            </p>
          </div>
        </div>

        <div className="text-gray-700 flex flex-col flex-col-reverse lg:flex-row lg:gap-[2px] justify-between items-center mt-[50px] mb-[50px]">
          <div className="lg:w-1/2 flex items-center text-gray-700">
            <p className="mb-0">
              {" "}
              We envision a future where lead generation is effortless, intelligent, and highly efficient. By harnessing the power of Assistive Intelligence, our AI Sales Chatbot is redefining how businesses connect with potential customers—ensuring seamless engagement, smarter qualification, and faster conversions. Our goal is to set new standards in sales automation, empowering businesses to capture and nurture leads effortlessly in the digital age.
            </p>
          </div>
          <div className="lg:w-1/2 flex justify-center">
            <h2 className="mt-[50px] text-[36px] lg:text-[48px] text-gray-700">
              <b>Vision</b>
            </h2>
            <img
              src="https://d2qb2qddg7l6c6.cloudfront.net/assets/images/visionIcon.svg"
              alt="visionIcon"
            />
          </div>
        </div>

        <div className="text-gray-700 flex flex-col lg:flex-row lg:gap-[2px] justify-between items-center mt-[50px] mb-[50px]">
          <div className="lg:w-1/2 flex items-center">
            <img
              src="https://d2qb2qddg7l6c6.cloudfront.net/assets/images/technologyIcon.svg"
              alt="missionIcon"
            />
            <h3 className="text-[36px] lg:text-[48px] text-gray-700">
              <b>Technology</b>
            </h3>
          </div>
          <div className="lg:w-1/2">
            <p>
            At LegittMate AI, we harness cutting-edge technology to revolutionize lead generation and customer engagement. Our AI Sales Chatbot integrates advanced machine learning, natural language processing (NLP), and intelligent automation to qualify leads, capture prospect data, and streamline initial interactions. By automating repetitive tasks and providing real-time insights, our chatbot enables businesses to enhance efficiency, improve response times, and maximize conversion potential—empowering sales teams to focus on closing deals faster.
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-start mt-[100px] mb-[50px]">
          <div className="w-full">
            <AccordianScroll />
          </div>
        </div>

        <div className="flex flex-col text-gray-700 items-center text-[15px]l text-center mt-16 mb-16">
          <h1 className="text-3xl lg:text-4xl font-bold mb-4">
            We Care About Your Business
          </h1>
          <p className="mb-4 max-w-2xl text-[14px] sm:text-[16px]">
            LegittMate AI is more than just a sales chatbot—it’s a game-changer in lead generation and customer engagement. With our forward-thinking approach, cutting-edge AI technology, and dedication to excellence, we empower businesses to connect with prospects seamlessly, qualify leads efficiently, and accelerate sales growth. Join us on this journey to redefine lead generation and unlock new opportunities with LegittMate AI, where smarter conversations drive better conversions.
          </p>
          <a href="https://legittmateai.com/demo">
            <button className="contained">Get A Demo</button>
          </a>
        </div>
      </div>
    </div>
    </>
  );
}
